import { Button, DatePicker, Table } from 'antd';
import { plantApi } from 'api/plantApi';
import { useAppSelector } from 'app/hooks';
import AddEditFormMaintenance from 'components/Common/Modal/AddEditFormMaintenance';
import { selectPlantItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import MaintenanceInfo from 'features/Plant/components/MaintenanceInfo/MaintenanceInfo';
import { maintenance } from 'models';
import moment from 'moment';
import * as React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { GrAddCircle } from 'react-icons/gr';
import style from './PlantMaintenance.module.scss';

export interface PlantMaintenanceProps {}

export default function PlantMaintenance(props: PlantMaintenanceProps) {
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const userInfo = useAppSelector(selectUserInfo);
  const [today, setToday] = React.useState(moment());
  const [maintenanceInfo, setMaintenanceInfo] = React.useState<any>(null);
  const [isShowCurrent, setIsShowCurrent] = React.useState<any>(null);
  const [maintenanceList, setMaintenanceList] = React.useState<maintenance[] | null>(null);
  const [isEvent, setIsEvent] = React.useState<boolean | null>(null);
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (plantItemSelected) {
      (async () => {
        const responseOne: maintenance = await plantApi.fetchMaintenanceInfo({
          type: 'maintenance-plan',
          id: plantItemSelected,
        });
        if (Object.keys(responseOne).length !== 0) {
          setMaintenanceInfo({
            title: responseOne.title,
            time: moment(responseOne.time),
            jobs: responseOne.jobs,
            description: responseOne.description,
            result_note: responseOne.result_note,
            assigned_to: responseOne.assigned_to.toString(),
          });
          setIsShowCurrent({
            title: responseOne.title,
            time: moment(responseOne.time),
            jobs: responseOne.jobs,
            description: responseOne.description,
            result_note: responseOne.result_note,
            assigned_to: responseOne.assigned_to.toString(),
          });
        }
        const responseTwo: maintenance[] = await plantApi.fetchMaintenanceList({
          type: 'maintenance-history',
          id: plantItemSelected,
          start_time: moment(moment(today).format('YYYY')).valueOf(),
          end_time: moment(moment(today).add('y', 1).format('YYYY')).valueOf(),
        });
        setMaintenanceList(responseTwo);
      })();
    }
  }, [plantItemSelected]);

  const onChange = async (values: moment.Moment | null) => {
    const day: moment.Moment = moment(values);
    setToday(day);
    const responseTwo: maintenance[] = await plantApi.fetchMaintenanceList({
      type: 'maintenance-history',
      id: plantItemSelected,
      start_time: moment(moment(values).format('YYYY')).valueOf(),
      end_time: moment(moment(values).add('y', 1).format('YYYY')).valueOf(),
    });
    setMaintenanceList(responseTwo);
  };

  const columns = [
    {
      title: 'Thời gian',
      dataIndex: 'time',
      key: 'time',
      render: (time: number) => <p>{moment(time).format('YYYY-MM-DD')}</p>,
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
    },
    {
      title: 'Người phụ trách',
      dataIndex: 'assigned_to',
      render: (text: string[]) => <p>{text.toString()}</p>,
    },
    {
      title: 'Mức hoàn thành',
      dataIndex: 'completed',
    },
    {
      title: 'Hoàn thành',
      dataIndex: 'completed_time',
      render: (completed_time: number) => <p>{moment(completed_time).format('YYYY-MM-DD')}</p>,
    },
  ];

  const showMaintenance_Info = async (item: maintenance) => {
    console.log(
      'Log: ~ file: PlantMaintenance.tsx ~ line 93 ~ constshowMaintenance_Info= ~ item',
      item
    );
    await setMaintenanceInfo({
      title: item.title,
      time: moment(item.time),
      jobs: item.jobs,
      description: item.description,
      result_note: item.result_note,
      assigned_to: item.assigned_to.toString(),
    });
    await setIsEvent(null);
    setIsModalVisible(true);
  };

  return (
    <div className={style.root}>
      <div className={style.header_maintenance_info}>
        <div className={style.title_maintenance_info}>
          <div>Lịch bảo trì hiện tại</div>
          {isShowCurrent && (
            <div
              onClick={async () => {
                await setIsEvent(false);
                await setMaintenanceInfo(isShowCurrent);
                setIsModalVisible(true);
              }}
              className={style.details_maintenance}
            >
              chi tiết
              <FiAlertCircle
                style={{
                  marginLeft: '10px',
                  fontSize: '20px',
                }}
              />
            </div>
          )}
        </div>
        <div className={style.content_maintenance_info}>
          {isShowCurrent ? (
            <MaintenanceInfo maintenanceInfo={isShowCurrent} />
          ) : (
            userInfo?.authority !== 'CUSTOMER_USER' && (
              <Button
                type="link"
                size="large"
                onClick={async () => {
                  await setMaintenanceInfo(null);
                  await setIsEvent(true);
                  setIsModalVisible(true);
                }}
                className={style.btn_maintenance}
                icon={<GrAddCircle size={15} style={{ marginRight: '5px' }} />}
              >
                Tạo lịch bảo trì
              </Button>
            )
          )}
        </div>
      </div>
      <div className={style.container_maintenance}>
        <div className={style.header_maintenance_container}>
          <div className={style.title_maintenance_container}>Lịch bảo trì</div>
          <div className={style.title_maintenance_container}>
            <DatePicker
              style={{ backgroundColor: '#000', border: 'none' }}
              onChange={onChange}
              defaultValue={today}
              picker="year"
            />
          </div>
        </div>
        {maintenanceList !== null && (
          <Table
            pagination={{
              pageSize: 7,
            }}
            columns={columns}
            dataSource={maintenanceList}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  showMaintenance_Info(record);
                }, // click row
              };
            }}
          />
        )}
      </div>
      {isModalVisible && (
        <AddEditFormMaintenance
          isEvent={isEvent}
          maintenanceInfo={maintenanceInfo}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          setIsShowCurrent={setIsShowCurrent}
          setMaintenanceList={setMaintenanceList}
          today={today}
        />
      )}
    </div>
  );
}
